import { QueryClient } from "@tanstack/react-query"

// gcTime generous so the persisted offline cache stays resident to be captured.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 1000 * 60 * 60 * 24,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
